import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  navigationLabel: {
    id: 'frontbucket.horizontalNav.globalLabel',
    description:
      'Describes the specific role of this navigation component for users viewing the page with a screen reader. Differentiates from other navigation components on a page.',
    defaultMessage: 'Global navigation',
  },
  createButtonLabel: {
    id: 'frontbucket.horizontalNav.createButtonLabel',
    description:
      'Label for the button which when clicked reveals the Create drawer.',
    defaultMessage: 'Create',
  },
  repositorySectionHeading: {
    id: 'frontbucket.horizontalNav.repositorySectionHeading',
    description: 'Heading for the repository section in the create dropdown.',
    defaultMessage: 'This repository',
  },
  createButtonAriaLabel: {
    id: 'frontbucket.horizontalNav.createButtonAriaLabel',
    description:
      'Aria label for the button which when clicked reveals the Create menu.',
    defaultMessage: 'Toggle create menu',
  },
  search: {
    id: 'frontbucket.horizontalNav.searchLabel',
    description:
      'Label for the search input which allows users to find code and repositories.',
    defaultMessage: 'Search',
  },
  helpTooltip: {
    id: 'frontbucket.horizontalNav.helpLabel',
    description: 'Tooltip for the help menu trigger.',
    defaultMessage: 'Help',
  },
  bitbucketHomeAriaLabel: {
    id: 'frontbucket.horizontalNav.bitbucketHomeAriaLabel',
    description:
      'Aria label for the button which when clicked redirect to the dashboard.',
    defaultMessage: 'Bitbucket home',
  },
  settings: {
    id: 'frontbucket.horizontalNav.settings',
    description: 'Label for the product settings nav item',
    defaultMessage: 'Settings',
  },
  bitbucketAdministration: {
    id: 'frontbucket.horizontalNav.settings.bitbucketAdministration',
    description: 'Header for the bitbucket administration section',
    defaultMessage: 'Bitbucket Administration',
  },
  personalSettings: {
    id: 'frontbucket.horizontalNav.settings.personalSettings',
    description: 'Header for the personal settings section',
    defaultMessage: 'Personal Settings',
  },
  workspaceSettingsTitle: {
    id: 'frontbucket.horizontalNav.settings.workspaceSettingsTitle',
    description: 'Title for the workspace settings link',
    defaultMessage: 'Workspace settings',
  },
  workspaceSettingsDesc: {
    id: 'frontbucket.horizontalNav.settigns.workspaceSettingsDesc',
    description: 'Description for the workspace settings link',
    defaultMessage: 'Manage your workspace settings and integrations.',
  },
  atlAcctSettingsTitle: {
    id: 'frontbucket.horizontalNav.settings.atlAcctSettingsTitle',
    description: 'Title for the Atlassian account settings link',
    defaultMessage: 'Atlassian account settings',
  },
  atlAcctSettingsDesc: {
    id: 'frontbucket.horizontalNav.settings.atlAcctSettingsDesc',
    description: 'Description for the Atlassian account settings link',
    defaultMessage:
      'Manage your language, time zone, and other profile information.',
  },
  bbAcctSettingsTitle: {
    id: 'frontbucket.horizontalNav.settings.bbAcctSettingsTitle',
    description: 'Title for the Bitbucket account settings link',
    defaultMessage: 'Personal Bitbucket settings',
  },
  bbAcctSettingsDesc: {
    id: 'frontbucket.horizontalNav.settings.bbAcctSettingsDesc',
    description: 'Description for the Bitbucket account settings link',
    defaultMessage:
      'Manage your email notification and other Bitbucket settings.',
  },
  labsTitle: {
    id: 'frontbucket.horizontalNav.settings.labsTitle',
    description: 'Title for the Labs settings link',
    defaultMessage: 'Labs',
  },
  labsDesc: {
    id: 'frontbucket.horizontalNav.settings.labsDesc',
    description: 'Description for the Labs settings link',
    defaultMessage:
      "Help us test these new or experimental features before they are released. Remember, these features aren't completely finished and might change, break, or disappear at any time.",
  },
  atlassianAdmin: {
    id: 'frontbucket.horizontalNav.settings.atlassianAdmin',
    description: 'Header for the Atlassian admin section',
    defaultMessage: 'Atlassian Admin',
  },
  billingTitle: {
    id: 'frontbucket.horizontalNav.settings.billingTitle',
    defaultMessage: 'Billing management',
    description: 'Title for the billing link',
  },
  billingDesc: {
    id: 'frontbucket.horizontalNav.settings.billingDesc',
    defaultMessage: 'Manage billing, plans, subscriptions.',
    description: 'Description for the billing link',
  },
  userManagementTitle: {
    id: 'frontbucket.horizontalNav.settings.userManagementTitle',
    description: 'Title for the Atlassian admin user management link',
    defaultMessage: 'User management',
  },
  userManagementDesc: {
    id: 'frontbucket.horizontalNav.settigns.userManagementDesc',
    description: 'Description for the Atlassian admin user management link',
    defaultMessage: 'Add users, groups, and manage access requests.',
  },
});
